export default __webpack_public_path__ + "static/media/bridal2.303a18f1.jpg";